import { Option, Select } from 'carbon-react/lib/components/select';
import React from 'react';

import { useIntl } from '@futrli/localisation';

import { adaptSelectChange } from '../../../../utils/carbon-select';

import { OutputFrequency } from '../../types';

interface OutputFrequencyMenuProps {
  className?: string;
  disabled?: boolean;
  error?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: OutputFrequency;
  size?: 'small' | 'medium' | 'large';
}

export const OutputFrequencyMenu = ({
  disabled = false,
  error,
  onChange,
  value,
  size = 'large'
}: OutputFrequencyMenuProps) => {
  const intl = useIntl();

  const label = intl.formatMessage({
    id: 'predict.output_frequency',
    defaultMessage: 'Output frequency'
  });

  return (
    <div style={{ width: 185, marginRight: 16 }}>
      <Select
        data-testid="OutputFrequencyMenu"
        autoComplete="off"
        onChange={adaptSelectChange(onChange)}
        value={value ?? ''}
        label={label}
        disabled={disabled}
        error={error}
        size={size}
        mb={0}
      >
        <Option
          value={OutputFrequency.daily}
          text={intl.formatMessage({ id: 'common.output_frequency_daily', defaultMessage: 'Daily' })}
        />
        <Option
          value={OutputFrequency.monthly}
          text={intl.formatMessage({ id: 'common.output_frequency_monthly', defaultMessage: 'Monthly' })}
        />
        <Option
          value={OutputFrequency.annually}
          text={intl.formatMessage({ id: 'common.output_frequency_annually', defaultMessage: 'Annually' })}
        />
      </Select>
    </div>
  );
};
